import styled from 'styled-components';
import { motion } from 'framer-motion';

import { white, black, primary } from 'constants/color';

export const StyledViewer = styled.div`
  width: auto;
  overflow: auto;
  margin-top: 10px;
  max-height: 300px;
  padding-right: 10px;
  ${({ theme }) => theme.scrollbar};
`;

export const StyledMessage = styled.p`
  padding: 5px;
  color: #ff0000;
  font-size: 15px;
  margin-top: 10px;
  font-weight: 400;
  margin-bottom: 5px;
  line-height: 22.5px;
  background-color: #e7ffec;
`;

export const StyledRowErrors = styled.ul`
  color: #ff0000;
  font-size: 13px;
  margin-top: 0px;
  line-height: 19.5px;
  padding-left: 20px;
  margin-bottom: 10px;
`;

export const StyledFileName = styled.p`
  font-size: 15px;
  margin-top: 10px;
  font-weight: 400;
  margin-left: 10px;
  margin-bottom: 5px;
  line-height: 22.5px;
  display: inline-block;
`;

export const StyledHeading = styled.h3`
  color: #5d5d5d;
  font-size: 15px;
  margin-top: 0px;
  margin-bottom: 5px;
  line-height: 22.5px;
`;

export const StyledSubHeading = styled.h4`
  color: #000000;
  font-size: 12px;
  margin-top: 0px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 5px;
`;

export const StyledTips = styled.b``;

export const StyledTip = styled.p`
  color: #000000;
  font-size: 12px;
  margin-top: 2px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 0px;
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  button:nth-child(2) {
    margin-left: 10px;
  }
`;

export const StyledForm = styled.form`
  margin-top: 10px;
`;

export const StyledFileInput = styled.input`
  display: none;
`;

export const StyledLabel = styled.label`
  cursor: pointer;
`;

export const StyledContainer = styled.div`
  padding: 15px;
  background-color: ${white};
`;

export const StyledDownLoadButton = styled.button`
  border: none;
  cursor: pointer;
  margin-left: 20px;
  padding: 5px 10px;
  color: ${({ theme }) => theme.primaryColor};
  /* Mobile Devices */
  @media (max-width: 480px) {
    width: 100%;
    margin: 10px 0;
    padding: 10px 0;
  }
`;

export const StyledDownloadWrapper = styled.div`
  display: flex;
  margin: 10px 0;
  align-items: center;
  /* Mobile Devices */
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StyledButton = styled(motion.button)`
  height: 40px;
  border: none;
  min-width: 20%;
  color: ${white};
  cursor: pointer;
  box-shadow: none;
  margin-bottom: 0;
  padding: 6px 12px;
  user-select: none;
  text-align: center;
  white-space: nowrap;
  text-transform: none;
  vertical-align: middle;
  line-height: 1.42857143;
  -webkit-box-shadow: none;
  -webkit-user-select: none;
  background-color: ${primary};
  border-radius: ${({ theme }) => theme.borderRadius};
  svg {
    width: 20px;
    height: 20px;
    fill: ${white};
    margin-right: 5px;
    vertical-align: sub;
  }
`;

export const StyledTableWrapper = styled.div`
  --color: ${({ $import }) => ($import ? primary : '#d3d3d3')};
  color: ${black};
  margin-top: 10px;
  overflow-x: auto;
  table {
    width: 100%;
  }
  table,
  th,
  td {
    border-collapse: collapse;
    border: 1px solid var(--color);
  }
  td {
    font-size: 12px;
    padding-left: 5px;
  }
  tr td:first-child {
    padding: 1px 5px;
  }
`;

export const StyledNameWrapper = styled.div`
  display: flex;
  align-items: center;
`;
